import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { Image } from 'semantic-ui-react'
import CrosschqLogo from '@ui/Logo'

@inject('surveyState')
@observer
class OrganizationLogo extends Component {
  render() {
    const { surveyState } = this.props

    return surveyState.hasBrandLogo ? (
      <div className='organization-logo-container'>
        <Image src={surveyState.brandLogo} />
      </div>
    ) : (
      <CrosschqLogo />
    )
  }
}

export default withTranslation()(OrganizationLogo)
